import { Stack, Typography } from '@mui/material';
import Modal from 'new/components/Modal';
import { ModalContent } from 'new/components/ModalContent/styles';
import { useExternalPatientsStore } from '../../hooks';
import Button from 'new/components/Button/Button';
import { TENANT } from 'new/tenants';

type Props = {
  hasInsured: boolean;
};

const PlanTypeSelectorModal: React.FC<Props> = ({ hasInsured }) => {
  const { planType, setPlanType } = useExternalPatientsStore();
  return (
    <Modal open={hasInsured && !planType}>
      <ModalContent>
        <Typography
          textAlign="center"
          fontSize="2.925rem"
          style={{ color: '#474747' }}
        >
          <b>
            Are you <u>insured</u> or <u>uninsured</u> for{' '}
            {TENANT.nameSimple.toLowerCase()} care?
          </b>
        </Typography>
        <Stack direction="row" gap={4} mt={4}>
          <Button
            onClick={() => {
              setPlanType?.('insured');
            }}
          >
            Insured
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setPlanType?.('uninsured');
            }}
          >
            Uninsured
          </Button>
        </Stack>
      </ModalContent>
    </Modal>
  );
};

export default PlanTypeSelectorModal;
